import axios from 'axios';

export default axios.create({
  baseURL: 'https://admin.api.toysspaceshop.com/api',
  headers: {
    'Content-type': 'application/json',
  },
});
